import React from 'react'

interface CheckSvgIconProps {
  className?: string
}

export const LeftIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.793 14.293C22.1835 13.9025 22.8165 13.9025 23.207 14.293C23.5976 14.6835 23.5976 15.3166 23.207 15.7071L18.9141 20L23.207 24.293C23.5976 24.6835 23.5976 25.3166 23.207 25.7071C22.8165 26.0976 22.1835 26.0976 21.793 25.7071L16.0859 20L21.793 14.293Z"
        fill="#101A36"
      />
    </svg>
  )
}
export const TickSvgIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4999 4.50001C13.6952 4.69525 13.6952 5.0118 13.4999 5.20704L6.49995 12.207L2.49995 8.20704C2.30471 8.0118 2.30471 7.69525 2.49995 7.50001C2.69519 7.30477 3.01174 7.30477 3.20698 7.50001L6.49995 10.793L12.7929 4.50001C12.9882 4.30477 13.3047 4.30477 13.4999 4.50001Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const PlusSvgIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8H13M8.005 3.005L8.005 13.005"
        stroke="#101A36"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
export const MinusSvgIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 9.36401C17.2202 9.36401 17.5 9.64384 17.5 9.98901C17.5 10.3342 17.2202 10.614 16.875 10.614H3.125C2.77982 10.614 2.5 10.3342 2.5 9.98901C2.5 9.64384 2.77982 9.36401 3.125 9.36401H16.875Z"
        fill="#101A36"
      />
    </svg>
  )
}
export const PlusCountIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 9.99998H16.25M10.0063 3.75623L10.0062 16.2562"
        stroke="#101A36"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
export const ChevroIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="24"
      height="19"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2202 15.1297C13.7472 17.1289 13.0106 18.1285 12 18.1285C10.9894 18.1285 10.2528 17.1289 8.77978 15.1297L2.69575 6.8728C0.643987 4.08827 -0.381893 2.696 0.172935 1.598C0.727764 0.5 2.45717 0.5 5.91597 0.500001L18.084 0.500001C21.5428 0.500002 23.2722 0.500002 23.8271 1.598C24.3819 2.696 23.356 4.08827 21.3043 6.8728L15.2202 15.1297Z"
        fill="currentCOlor"
      />
    </svg>
  )
}
export const InfoIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2082_20697)">
        <path
          d="M7 6.125C7.48325 6.125 7.875 6.51675 7.875 7V10.0625C7.875 10.5457 7.48325 10.9375 7 10.9375C6.51675 10.9375 6.125 10.5457 6.125 10.0625V7C6.125 6.51675 6.51675 6.125 7 6.125Z"
          fill="#101A36"
          fillOpacity="0.7"
        />
        <path
          d="M7 3.0625C7.48325 3.0625 7.875 3.45425 7.875 3.9375V4.375C7.875 4.85825 7.48325 5.25 7 5.25C6.51675 5.25 6.125 4.85825 6.125 4.375V3.9375C6.125 3.45425 6.51675 3.0625 7 3.0625Z"
          fill="#101A36"
          fillOpacity="0.7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75Z"
          fill="#101A36"
          fillOpacity="0.7"
        />
      </g>
      <defs>
        <clipPath id="clip0_2082_20697">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const CircleIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="440"
      height="65"
      viewBox="0 0 440 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="220" cy="32.5" rx="220" ry="32.5" fill="white" />
    </svg>
  )
}
export const ChevronRightIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.5 5L12.5 10L7.5 15" stroke="#101A36" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}
export const CheckIcon = (props: CheckSvgIconProps) => {
  return (
    <svg
      className={props.className ?? ''}
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 36L29.25 51.75L58.5 22.5"
        stroke="#349760"
        strokeWidth="8"
        strokeLinecap="round"
      />
    </svg>
  )
}
